// src/pages/Auth/EmailVerifyPage.jsx

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { serverDomain } from "../../config";
import "./login.css";

const Header = () => (
    <header className="header">
        <div className="logo">
            <span>Fl-Dating</span>
        </div>
    </header>
);

function getCookie(name) {
    const m = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : null;
}

function clearRefMark() {
    try {
        localStorage.removeItem('ref');
        localStorage.removeItem('ref_code');
        document.cookie = 'ref=; Max-Age=0; path=/; samesite=lax';
    } catch (_) {}
}

const EmailVerifyPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [message, setMessage] = useState("Подтверждаем ваш email...");
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");

        if (!token) {
            setIsError(true);
            setMessage("Некорректная ссылка подтверждения.");
            return;
        }

        const verify = async () => {
            try {
                const refFromUrl = (params.get("ref") || "").trim();
                const refFromLS = (localStorage.getItem('ref_code') || localStorage.getItem('ref') || '').trim();
                const refFromCK = (getCookie('ref') || '').trim();
                const ref = refFromUrl || refFromLS || refFromCK || null;

                const res = await axios.post(`${serverDomain}/api/auth/verify`, {
                    token,
                    ref
                });

                setIsError(false);
                setMessage(res.data.message || "Email подтверждён");
                clearRefMark();

            } catch (err) {
                setIsError(true);
                setMessage(err.response?.data?.message || "Ошибка подтверждения");
            }
        };

        verify();
    }, [location.search, navigate]);

    return (
        <div className="auth-page">
            <Header />
            <div className="login-container">
                    <div
                        className={
                            "verify-icon " + (isError ? "verify-icon--error" : "verify-icon--success")
                        }
                    >
                        {isError ? "⚠️" : "✅"}
                    </div>
    
                    <h2 className="verify-title">Подтверждение Email</h2>
    
                    <p
                        className={
                            "verify-message " + (isError ? "verify-message--error" : "verify-message--ok")
                        }
                    >
                        {message}
                    </p>

                    {!isError && (
                        <p className="verify-info">
                            Для быстрой модерации вашего аккаунта, напишите в Telegram —{" "}
                            <a href="https://t.me/fl_assistance" target="_blank" rel="noopener noreferrer">
                                t.me/fl_assistance
                            </a>
                        </p>
                    )}

    
                    <button
                        type="button"
                        className="verify-btn"
                        onClick={() => navigate("/login?reason=registration_success")}
                    >
                        Войти в аккаунт
                    </button>
    
                    <button
                        type="button"
                        className="verify-btn-secondary"
                        onClick={() => navigate("/")}
                    >
                        На главную
                    </button>
            </div>
        </div>
    );    
    
};

export default EmailVerifyPage;
